import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { Skeleton } from "primereact/skeleton";
import { OverlayPanel } from 'primereact/overlaypanel';
import { ColorPicker, ColorPickerChangeEvent } from 'primereact/colorpicker';

import NoDataCreated from "../../../../../../Components/NoDataCreated";
import ErrorPage from "../../../../../../Components/ErrorPage";
import TextInput from "../../../../../../Components/TextInput";
import { goToTop } from "../../../../../../Components/goToTop";

import { useAppDispatch, useAppSelector } from "../../../../../../Controllers/hooks";
import { fetchAllProgramme } from "../../../../../../Controllers/Thunks/programmeThunks";
import { colorCodeGetDataApi, commonIconGetDataApi } from "../../../../../../Api/Project/DefaultServices/Program/ProgramApi";
import { ColorCode, CommonIcon, TaskLibrary } from "../../../../../../Controllers/Types/Project/DefaultService/ProgramInterface";
import { baseURL } from "../../../../../../Api/ApiConstant";
import { checkFileImage, checkNumber, checkText } from "../../../../../../Utils/Validator";
import { taskLibraryCreateApi, taskLibraryDeleteApi, taskLibraryUpdateApi } from "../../../../../../Api/Project/DefaultServices/Program/ProgramTaskLibraryApi";
import { colorCodeCreateApi, commonIconCreateApi } from "../../../../../../Api/Project/DefaultServices/Program/ProgramApi";
import { Message } from "primereact/message";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { confirmDialog } from "primereact/confirmdialog";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../Controllers/Store";
import { hasPermission } from "../../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../../Components/TableActionLoader";

const ProgrammeTask: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const projectData = location.state?.data;
    const serviceId = Number(projectData.folder_id);
    // const isShared: boolean = projectData.sharedBy !== null ? true : false;
 const isShared: boolean = projectData.can_edit===false ? true : false;

    const taskLibraryList = useAppSelector((state) => state.programme.taskLibrary);
    const error = useAppSelector((state) => state.programme.error);

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Edit');
    const [deleteTaskLoading, setDeleteTaskLoading] = useState<boolean>(false);

    const [loadingTaskData, setLoadingTaskData] = useState<boolean>(true);
    const [showProgrammeTaskLibraryModal, setShowProgrammeTaskLibraryModal] = useState<boolean>(false);
    const [taskColorOptions, setTaskColorOptions] = useState<ColorCode[]>([]);
    const [taskIconOptions, setTaskIconOptions] = useState<CommonIcon[]>([]);
    const [taskLibraryData, setTaskLibraryData] = useState<TaskLibrary[]>([]);
    const [selectedTaskLibraryData, setSelectedTaskLibraryData] = useState<TaskLibrary | null>(null);

    const [taskSearchKey, setTaskSearchKey] = useState<string>("");
    const [taskUpdateHasChanges, setTaskUpdateHasChanges] = useState<boolean>(false);
    const [taskViewState, setTaskViewState] = useState<'Custom' | 'Default'>('Custom');

    const [taskName, setTaskName] = useState<string>('');
    const [taskColorId, setTaskColorId] = useState<number | null>(null);
    const [taskIconId, setTaskIconId] = useState<number | null>(null);

    const [taskNameError, setTaskNameError] = useState<string>('');
    const [taskColorError, setTaskColorError] = useState<string>('');
    const [taskIconError, setTaskIconError] = useState<string>('');

    /*  */
    const colorPickerPanel = useRef<OverlayPanel | null>(null);
    const [pickedColor, setPickedColor] = useState<string | undefined>('EEEEEE');
    const [customLoading, setCustomLoading] = useState<boolean>(false);
    const [pickedColorError, setPickedColorError] = useState<string>('');

    const iconUploadPanel = useRef<OverlayPanel | null>(null);
    const [uploadedIcon, setUploadedIcon] = useState<string | null>(null);
    const [uploadedIconFile, setUploadedIconFile] = useState<File | null>(null);
    const [uploadedIconError, setUploadedIconError] = useState<string>('');
    /*  */

    /* Permission handler */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermission_add_task_library = useCanEdit('Programe', 'add_task_library');
    const isPermission_edit_task_library = useCanEdit('Programe', 'edit_task_library');
    const isPermission_delete_task_library = useCanEdit('Programe', 'delete_task_library');
    /*  */

    /* Pagination */
    const [first, setFirst] = useState<number>(0);
    const [rows, setRows] = useState<number>(12);

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    /*  */

    useEffect(() => {
        programTaskDataGet();
        colorCodeDataGet();
        commonIconDataGet();
    }, []);

    useEffect(() => {
        let filteredData: TaskLibrary[] = taskLibraryList;

        if (taskViewState === 'Custom') {
            filteredData = filteredData.filter((task) => task?.editable === true);
        } else {
            filteredData = filteredData.filter((task) => task?.editable === false);
        }

        const searchFilterData = filteredData.filter((task) =>
            task?.task_name?.toLowerCase().includes(taskSearchKey.toLowerCase())
        );

        setTaskLibraryData(searchFilterData);
    }, [taskLibraryList, taskSearchKey, taskViewState]);


    /* ********************************* get data list ************************************************** */
    const programTaskDataGet = async () => {
        if (serviceId) {
            dispatch(fetchAllProgramme(serviceId));
        }
    }
    const colorCodeDataGet = async () => {
        const data = await colorCodeGetDataApi();
        if (data.status) {
            setTaskColorOptions(data.data || []);
        }
    }
    const commonIconDataGet = async () => {
        const data = await commonIconGetDataApi();
        if (data.status) {
            setTaskIconOptions(data.data || []);
        }
    }
    /* ********************************* get data list ************************************************** */


    const paginatedTasksData = taskLibraryData.slice(first, first + rows);

    /****************************************** Program task ****************************************/
    const handleCloseProgrammeTaskLibraryModal = () => {
        setShowProgrammeTaskLibraryModal(false);

        handleClearFields();
        handleClearErrors();
    }

    const handleClearFields = () => {
        setTaskName('');
        setTaskColorId(null);
        setTaskIconId(null);
    }

    const handleClearErrors = () => {
        setTaskNameError('');
        setTaskColorError('');
        setTaskIconError('');
    }

    const handleAddProgrammeTaskLibrary = () => {
        setDataState('Add');
        setShowProgrammeTaskLibraryModal(true);

        handleClearFields();
        handleClearErrors();
    }

    /* ******************************************************** checkCredentials  *************************************************************************** */
    useEffect(() => {
        checkText(taskName, false, setTaskNameError)
    }, [taskName]);

    useEffect(() => {
        checkNumber(taskColorId || 0, false, setTaskColorError);
    }, [taskColorId]);

    useEffect(() => {
        checkNumber(taskIconId || 0, false, setTaskIconError);
    }, [taskIconId]);

    function checkCredentials(): boolean {
        const isTaskNameValid = checkText(taskName, true, setTaskNameError);
        const isTaskColorIdValid = checkNumber(taskColorId || 0, true, setTaskColorError);
        const isTaskIconIdValid = checkNumber(taskIconId || 0, true, setTaskIconError);

        return isTaskNameValid && isTaskColorIdValid && isTaskIconIdValid;
    }
    /* ******************************************************** checkCredentials  *************************************************************************** */

    /* ******************************************************** showAPIErrorData  *************************************************************************** */
    function showAPIErrorData(keyName: string, error: string): void {
        if (keyName === "task_name") {
            setTaskNameError(error);
        }

        if (keyName === "color_code") {
            setPickedColorError(error);
        }

        if (keyName === "path") {
            setUploadedIconError(error);
        }
    }
    /* ******************************************************** showAPIErrorData  *************************************************************************** */


    /* ******************************************************** Create  *************************************************************************** */
    const handleCreateProgrammeTaskLibrary = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await taskLibraryCreateApi(taskColorId || 0, taskIconId || 0, taskName);
            setLoading(false);

            if (data.statusCode === 200) {
                programTaskDataGet();
                handleCloseProgrammeTaskLibraryModal();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task created.',
                        detail: 'Task created successfully.',
                        life: 3000
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error creating the task.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ******************************************************** Create  *************************************************************************** */


    /* ******************************************************** Update  *************************************************************************** */
    useEffect(() => {
        if (selectedTaskLibraryData) {
            if (taskName !== selectedTaskLibraryData?.task_name) {
                setTaskUpdateHasChanges(true);
            } else if (taskColorId !== selectedTaskLibraryData?.color_code_id) {
                setTaskUpdateHasChanges(true);
            } else if (taskIconId !== selectedTaskLibraryData?.common_icon_id) {
                setTaskUpdateHasChanges(true);
            } else {
                setTaskUpdateHasChanges(false);
            }
        }
    }, [selectedTaskLibraryData, taskName, taskColorId, taskIconId])

    const handleEditProgrammeTaskLibrary = (task: TaskLibrary) => {
        setDataState('Edit');
        setShowProgrammeTaskLibraryModal(true);
        setSelectedTaskLibraryData(task);

        setTaskName(task?.task_name);
        setTaskColorId(task?.color_code_id);
        setTaskIconId(task?.common_icon_id);
    }

    const handleUpdateProgrammeTaskLibrary = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await taskLibraryUpdateApi(
                selectedTaskLibraryData?.id || 0,
                taskColorId || 0,
                taskIconId || 0,
                taskName
            );
            setLoading(false);

            if (data.statusCode === 200) {
                programTaskDataGet();
                handleCloseProgrammeTaskLibraryModal();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task updated.',
                        detail: 'Task updated successfully.',
                        life: 3000
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error updating the task.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ******************************************************** Update  *************************************************************************** */


    /* ******************************************************** Delete  *************************************************************************** */
    const handleDeleteTask = () => {
        if (selectedTaskLibraryData) {
            confirmDialog({
                message: `Are you sure you want to delete this task from the library? If a program task was created with this, it will also be deleted.`,
                header: 'Confirm the deletion',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                accept: () => deleteTask(selectedTaskLibraryData?.id || 0),
                resizable: false,
                draggable: false,
            });
        }
    }

    const deleteTask = async (taskLibraryId: number) => {
        if (taskLibraryId) {
            setDeleteTaskLoading(true);
            const data = await taskLibraryDeleteApi(taskLibraryId);

            setDeleteTaskLoading(false);
            if (data.statusCode === 200) {
                handleCloseProgrammeTaskLibraryModal();
                programTaskDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Task deleted.',
                        detail: 'The task was successfully deleted from the library.',
                        life: 3000
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error deleting the task from the library.',
                        life: 3000
                    });
                }
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Task not found.',
                    detail: 'Please select the task to be deleted from the library.',
                    life: 3000
                });
            }
        }
    }
    /* ******************************************************** Delete  *************************************************************************** */


    /* Modal header */
    const programmeTaskLibraryModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Create new task' : 'Edit task'}
            </h5>

            {dataState === 'Edit' ? (
                <React.Fragment>
                    {deleteTaskLoading ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <React.Fragment>
                            {isPermission_delete_task_library && !isShared && (
                                <button type="button" className="close_modal_btn p-ripple"
                                    onClick={() => handleDeleteTask()}>
                                    <i className="bi bi-trash3"></i>
                                    <Ripple />
                                </button>
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseProgrammeTaskLibraryModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const programmeTaskLibraryModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseProgrammeTaskLibraryModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateProgrammeTaskLibrary : handleUpdateProgrammeTaskLibrary}
                loading={loading} className="custom_btn primary"
                disabled={dataState === 'Edit' && !taskUpdateHasChanges}
            />
        </div>
    );

    const handleSelectColor = (option: ColorCode) => {
        if (option?.id !== taskColorId) {
            setTaskColorId(option?.id)
        } else {
            setTaskColorId(null);
        }
    }

    const handleSelectIcon = (option: CommonIcon) => {
        if (option?.id !== taskIconId) {
            setTaskIconId(option?.id)
        } else {
            setTaskIconId(null);
        }
    }

    const getColorCode = (colorId: number) => {
        const colorOption = taskColorOptions.find((option) => option?.id === colorId);
        return colorOption ? colorOption?.color_code : '';
    }

    const getIcon = (iconId: number) => {
        const iconOption = taskIconOptions.find((option) => option?.id === iconId);
        return iconOption ? baseURL + iconOption?.path : '';
    }

    useEffect(() => {
        if (taskColorOptions.length > 0 && taskIconOptions.length > 0) {
            setLoadingTaskData(false);
        } else {
            setLoadingTaskData(true);
        }
    }, [taskColorOptions, taskIconOptions]);
    /* ***************************************************************************************** */


    /* Common function */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    /* For color pick */
    const handleAddTaskColor = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (colorPickerPanel.current) {
            colorPickerPanel.current.toggle(e);
        }
    };

    const handleCloseColorPicker = () => {
        setPickedColor('EEEEEE');
        setPickedColorError('');

        if (colorPickerPanel.current) {
            colorPickerPanel.current.hide();
        }
    }

    function checkCredentialsForColor(): boolean {
        const isPickedColorValid = checkText(pickedColor!, true, setPickedColorError);

        return isPickedColorValid;
    }

    const handleAddColorToLibrary = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForColor()) {
            setCustomLoading(true);
            const formatedColorCode = ('#' + pickedColor!);

            const data = await colorCodeCreateApi(formatedColorCode);
            setCustomLoading(false);

            if (data.statusCode === 200) {
                colorCodeDataGet();
                handleCloseColorPicker();

            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error adding the color to the library.',
                        life: 3000
                    });
                }
            }
        }
    }

    /* For icon upload */
    const handleAddIcon = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (iconUploadPanel.current) {
            iconUploadPanel.current.toggle(e);
        }
    };

    const handleCloseIconUpload = () => {
        setUploadedIcon('');
        setUploadedIconFile(null);
        setUploadedIconError('');

        if (iconUploadPanel.current) {
            iconUploadPanel.current.hide();
        }
    }

    function checkCredentialsForIcon(): boolean {
        const isUploadedIconValid = checkText(uploadedIcon!, true, setUploadedIconError);
        const isUploadedIconFileValid = checkFileImage(uploadedIconFile!, true, setUploadedIconError);

        return isUploadedIconValid && isUploadedIconFileValid;
    }

    const handleIconUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setUploadedIcon(event.target.result);

                    const file = e.target.files?.[0];
                    setUploadedIconFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
            setTaskIconId(null);
        }
    }

    const handleClearIcon = () => {
        setUploadedIcon(null);
        setUploadedIconFile(null);
    };

    const handleAddIconToLibrary = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForIcon()) {
            setCustomLoading(true);

            const data = await commonIconCreateApi(uploadedIconFile!);
            setCustomLoading(false);

            if (data.statusCode === 200) {
                commonIconDataGet();
                handleCloseIconUpload();

            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error adding the icon to the library.',
                        life: 3000
                    });
                }
            }
        }
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.feature_name}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    Task
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area has_input_filter mt-sm-3 mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn ${taskViewState === 'Custom' ? "active" : ""} p-ripple`}
                                        onClick={() => setTaskViewState("Custom")}
                                    >
                                        Custom
                                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                    </button>
                                </div>
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn ${taskViewState === 'Default' ? "active" : ""} p-ripple`}
                                        onClick={() => setTaskViewState('Default')}
                                    >
                                        Default
                                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                    </button>
                                </div>
                            </div>

                            <div className="page_action_area">
                                <div className="filter_input_group">
                                    <IconField iconPosition="right">
                                        {taskSearchKey === "" ? (
                                            <InputIcon className="bi bi-search"></InputIcon>
                                        ) : (
                                            <InputIcon
                                                className="bi bi-x-lg search_clear_icon"
                                                onClick={() => setTaskSearchKey("")}
                                            ></InputIcon>
                                        )}

                                        <InputText
                                            id="taskSearchKey"
                                            value={taskSearchKey}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                setTaskSearchKey(e.target.value)
                                            }
                                            className="custom_form_input filter_input"
                                            placeholder="Search for a task by name"
                                            type="search"
                                        />
                                    </IconField>
                                </div>

                                {taskViewState === 'Custom' && isPermission_add_task_library && !isShared && (
                                    <button className="add_data_link_btn p-ripple" onClick={handleAddProgrammeTaskLibrary}>
                                        <i className="bi bi-plus-circle"></i>
                                        <span>Add task</span>
                                        <Ripple />
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="page_main_content_section p-sm-3 p-xxl-4 p-xl-3 p-lg-3 p-2">
                            {taskViewState === 'Custom' && taskLibraryData?.length > 0 && isPermission_edit_task_library && !isShared && (
                                <div className="page_form_group mb-4">
                                    <Message
                                        severity='info'
                                        className="message_text w-100"
                                        icon="bi bi-info-circle"
                                        style={{ border: '1px solid', borderRadius: '8px' }}
                                        text={`Click to view, edit, or delete the task.`}
                                    />
                                </div>
                            )}

                            {taskLibraryData?.length > 0 ? (
                                <div className="row sow_template_row">
                                    {paginatedTasksData?.map((task, index) => (
                                        <div key={index} className="col-12 col-sm-6 col-lg-6 col-xl-4">
                                            {loadingTaskData ? (
                                                <Skeleton className="sow_template_loading">
                                                    <Skeleton className="temp_icon_loading"></Skeleton>
                                                    <Skeleton className="temp_title_loading"></Skeleton>
                                                </Skeleton>
                                            ) : (
                                                <article className={`sow_template ${(task?.editable === false || !isPermission_edit_task_library || isShared) ? 'view_only' : ''} p-ripple`} style={{ backgroundColor: getColorCode(task?.color_code_id)! }}
                                                    onClick={() => (task?.editable && isPermission_edit_task_library && !isShared) && handleEditProgrammeTaskLibrary(task)}>
                                                    <div className="temp_icon">
                                                        <img src={getIcon(task?.common_icon_id)!} alt={task?.task_name} />
                                                    </div>
                                                    <h6 className="text-capitalize">{task?.task_name}</h6>
                                                    <Ripple />
                                                </article>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <NoDataCreated
                                    message={`${taskSearchKey ? 'The task you were looking for does not exist.' : taskViewState === 'Custom' ? `No tasks have been added to the library. ${!isShared && isPermission_add_task_library ? 'Click the Add button to add a task to the library.' : ''}` : 'There is no default task in the library.'}`}
                                />
                            )}
                        </div>

                        {taskLibraryData.length > 0 && (
                            <div className="pagination_area">
                                <Paginator
                                    first={first}
                                    rows={rows}
                                    totalRecords={taskLibraryData.length}
                                    rowsPerPageOptions={[12, 24, 36]}
                                    onPageChange={onPageChange}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Programme task modal */}
            <Dialog
                visible={showProgrammeTaskLibraryModal}
                header={programmeTaskLibraryModalHeader}
                footer={programmeTaskLibraryModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseProgrammeTaskLibraryModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <TextInput
                                    id="taskName"
                                    label="Task name"
                                    labelHtmlFor="taskName"
                                    required={true}
                                    value={taskName}
                                    placeholder="Title"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTaskName(e.target.value)}
                                    error={taskNameError}
                                />
                            </div>

                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="color" className="custom_form_label is_required">Select color</label>
                                    <div className="colors_options_area">
                                        {taskColorOptions?.length > 0 && (
                                            <React.Fragment>
                                                {taskColorOptions?.map((colorOption) => {
                                                    return (
                                                        <div key={colorOption?.id} className={`color_option p-ripple ${colorOption?.id === taskColorId ? 'selected' : ''}`}
                                                            onClick={() => handleSelectColor(colorOption)}
                                                            style={{ backgroundColor: colorOption?.color_code, borderColor: colorOption?.color_code }}>
                                                            <Ripple />
                                                        </div>
                                                    )
                                                })}
                                            </React.Fragment>
                                        )}

                                        <div className={`color_option picker p-ripple`}
                                            onClick={handleAddTaskColor}>
                                            <i className="bi bi-palette"></i>
                                            <Ripple />
                                        </div>

                                        <OverlayPanel
                                            ref={colorPickerPanel}
                                            className="color_picker_overlay"
                                            onHide={handleCloseColorPicker}
                                        >
                                            <div className="color_picker_area">
                                                <ColorPicker
                                                    value={pickedColor}
                                                    format="hex"
                                                    className="color_picker_inline"
                                                    inline
                                                    onChange={(e: ColorPickerChangeEvent) => {
                                                        if (typeof e.value === 'string') {
                                                            setPickedColor(e.value);
                                                        }
                                                    }}
                                                />

                                                <div className="color_picker_footer">
                                                    <div className="color_picked_label" style={{ backgroundColor: `#${pickedColor}` }}>
                                                        <span style={{ color: `#${pickedColor}`, filter: 'invert(1)' }}>
                                                            #{pickedColor}
                                                        </span>
                                                    </div>

                                                    {pickedColorError && (
                                                        <small className="form_error_msg">{pickedColorError}</small>
                                                    )}

                                                    <div className="color_picker_btn_area">
                                                        <Button
                                                            label="Cancel"
                                                            className="custom_btn secondary color_picker_btn"
                                                            onClick={handleCloseColorPicker}
                                                        />

                                                        <Button
                                                            label="Save"
                                                            onClick={handleAddColorToLibrary}
                                                            loading={customLoading}
                                                            className="custom_btn primary color_picker_btn"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </OverlayPanel>
                                    </div>
                                    {taskColorError && <small className="form_error_msg mt-2">{taskColorError}</small>}
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="icon" className="custom_form_label is_required">Select icon</label>
                                    <div className="icons_options_area">
                                        {taskIconOptions?.length > 0 && (
                                            <React.Fragment>
                                                {taskIconOptions?.map((iconOption) => {
                                                    return (
                                                        <div className={`icon_option p-ripple ${iconOption?.id === taskIconId ? 'selected' : ''}`}
                                                            onClick={() => handleSelectIcon(iconOption)}>
                                                            <img src={baseURL + iconOption?.path} alt="icon" />
                                                            <Ripple />
                                                        </div>
                                                    )
                                                })}
                                            </React.Fragment>
                                        )}

                                        <div className={`icon_option p-ripple`}
                                            onClick={handleAddIcon}>
                                            <i className="bi bi-plus-lg upload_icon"></i>
                                            <Ripple />
                                        </div>

                                        <OverlayPanel
                                            ref={iconUploadPanel}
                                            className="color_picker_overlay"
                                            onHide={handleCloseIconUpload}
                                        >
                                            <div className="color_picker_area">
                                                <div className="icon_picker_grp">
                                                    <label htmlFor="iconPicker" className={`icon_picker_container p-ripple ${uploadedIcon ? 'uploaded' : ''}`}>
                                                        <i className="bi bi-cloud-upload upload_icon"></i>
                                                        {!uploadedIcon && !uploadedIconFile && (
                                                            <span className="upload_text">Upload (.svg)</span>
                                                        )}

                                                        <img src={uploadedIcon ? uploadedIcon : ''} alt="Upload" />
                                                        <Ripple />
                                                        <input
                                                            type="file"
                                                            accept=".svg"
                                                            id="iconPicker"
                                                            onChange={handleIconUpload}
                                                        />
                                                    </label>
                                                    {uploadedIcon && (<i className="bi bi-x-circle-fill upload_clear" onClick={handleClearIcon}></i>)}
                                                </div>

                                                <div className="color_picker_footer">
                                                    {uploadedIconError && (
                                                        <small className="form_error_msg mb-2">{uploadedIconError}</small>
                                                    )}

                                                    <div className="color_picker_btn_area mt-0">
                                                        <Button
                                                            label="Cancel"
                                                            className="custom_btn secondary color_picker_btn"
                                                            onClick={handleCloseIconUpload}
                                                        />

                                                        <Button
                                                            label="Save"
                                                            onClick={handleAddIconToLibrary}
                                                            loading={customLoading}
                                                            className="custom_btn primary color_picker_btn"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </OverlayPanel>
                                    </div>
                                    {taskIconError && <small className="form_error_msg mt-2">{taskIconError}</small>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </React.Fragment>
    )
}

export default ProgrammeTask;